import ApplePayLimitInfo from 'features/moveMoney/screens/ApplePay/ApplePayLimitInfo';
import React from 'react';

export default function ApplePayLimitInfoPage() {
  return <ApplePayLimitInfo />;
}
